module.exports = __webpack_public_path__ + "img/Rectangle 19.e90342a0.png";